export default __webpack_public_path__ + "static/media/we.bb269c2d.svg";